export const iconFontAwesomeMoneyEthereum = (
	<i className="fa-solid fa-ethereum"></i>
);
